import React from 'react';
import { useTranslation } from 'react-i18next';
import AppShell from './AppShell';

const StudentLayout = () => {
  const { t } = useTranslation();
  return (
    <AppShell
      variant="navbar"
      chromeTone="light"
      contentTone="light"
      navItems={[]}
      roleLabel={t('common.student')}
      showLanguageSwitcher
    />
  );
};

export default StudentLayout;
